// extracted by mini-css-extract-plugin
export default {"loder-div":"Loader_loder-div__YETjQ","loader":"Loader_loader__bhRPW","animFw":"Loader_animFw__oDhQo","coli1":"Loader_coli1__Rypam","coli2":"Loader_coli2__vQm4W"};